"use strict";
// The storage packages (PRD-1678, ARCH-006 PRD-1678 amendment): additional
// document storage held on top of the tier's quota, at most one at a time. Pure
// (GEN-004).
//
// Price-free like the app catalogue: the amount is a line of the price book
// (`storage:<packageId>`), the GB figure is a constant of the product. The
// order of `STORAGE_PACKAGE_IDS` is smallest first, and it is what decides
// whether a change is an upgrade (applied now) or a reduction (scheduled).
Object.defineProperty(exports, "__esModule", { value: true });
exports.STORAGE_PACKAGE_IDS = void 0;
exports.storagePackageGb = storagePackageGb;
exports.isStoragePackageId = isStoragePackageId;
exports.storagePackageOf = storagePackageOf;
exports.isStoragePackageUpgrade = isStoragePackageUpgrade;
/** Every storage package, smallest first. */
exports.STORAGE_PACKAGE_IDS = ['storage-10', 'storage-50'];
const STORAGE_PACKAGE_GB = {
    'storage-10': 10,
    'storage-50': 50,
};
/** The GB a package adds to the tier's quota; none held adds nothing. An absent
 * value reads as none, so a tenant stored before the packages existed needs no
 * backfill (ARCH-006 PRD-1020 amendment point 10). */
function storagePackageGb(id) {
    return id ? STORAGE_PACKAGE_GB[id] : 0;
}
function isStoragePackageId(value) {
    return typeof value === 'string' && exports.STORAGE_PACKAGE_IDS.includes(value);
}
/** A stored value read as the held package: anything that is not one of the
 * packages — absent, `null`, a retired id — is none. */
function storagePackageOf(value) {
    return isStoragePackageId(value) ? value : undefined;
}
/** Whether moving from one holding to another adds storage. Anything else — less
 * storage, none, or the same package — is not an upgrade. */
function isStoragePackageUpgrade(from, to) {
    return storagePackageGb(to) > storagePackageGb(from);
}
//# sourceMappingURL=storage-package.js.map